import { useTranslation } from "react-i18next";
import LevelCard from "./LevelCard";

function LevelsSection() {
  const { t } = useTranslation("global");
  
  // Level 1 - 3 themes
  const level1Themes = [
    t("home.level1-theme1", "Sécurité de l'information (SSI)"),
    t("home.level1-theme2", "Qualité, Sécurité & santé au travail, Environnement (QSE)"),
    t("home.level1-theme3", "Responsabilité Sociétale des Entreprises (RSE)")
  ];
  
  // Level 2 - 4 themes
  const level2Themes = [
    t("home.level2-theme1", "Sécurité de l'information (SSI/ISO 27001)"),
    t("home.level2-theme2", "Qualité, Sécurité & santé au travail, Environnement (QSE)"),
    t("home.level2-theme3", "Responsabilité Sociétale des Entreprises (RSE)"),
    t("home.level2-theme4", "Protection des Données (RGPD)")
  ];
  
  return (
    <section id="levels" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-black">
            {t("home.choixNiveau")}
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto mt-4">
            {t("home.levels-description", "ISOeVAL propose deux niveaux d'évaluation de maturité pour répondre à vos besoins spécifiques")}
          </p>
          <div className="w-20 h-1 bg-blue-600 mx-auto mt-4"></div>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <LevelCard
            number="1" 
            description={t("home.niveau1")}
            themes={level1Themes}
          />
          
          <LevelCard 
            number="2" 
            description={t("home.niveau2")}
            themes={level2Themes}
          />
        </div>
      </div>
    </section>
  );
}
  
export default LevelsSection;